<template>
  <v-data-table
    v-if="!isSala"
    :headers="visualizarPontosMedalha ? headers : headersSemPontos"
    :items="perguntasAprovadas"
    class="elevation-1"
    hide-default-footer
    disable-pagination
    :expanded.sync="expanded"
    item-key="perguntaMunicipioId"
  >
    <template v-slot:item="props">
      <tr class="aprovada">
        <td
          @click="removeQuestion(props.item)"
          style="cursor: pointer"
          title="DESCARTAR QUESTÃO E EVIDÊNCIAS"
        >
          <img style="width: 30px" src="/assets/img/removeQuestion.png" />
        </td>
        <td>{{ props.item.nome }}</td>
        <td>{{ props.item.numero }}</td>
        <td>
          <div>
            <div>{{ props.item.texto }}</div>
          </div>
        </td>
        <td @click="openEvidence(props.item)" v-if="props.item.temArquivo">
          <div class="optionsExpanded">
            <div
              :class="`openExpanded ${
                expanded.length > 0 &&
                props.item.perguntaMunicipioId ===
                  expanded[0].perguntaMunicipioId
                  ? 'expandedClass'
                  : ''
              }`"
              v-if="
                isFullAdmin ||
                (groupsConfig.visualizarAprovadas && config.visualizarAprovadas)
              "
            ></div>
          </div>
        </td>
        <td v-else></td>
        <td v-if="!isSala">{{ props.item.pontos }}</td>
        <td width="300px">
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-file-input
              v-if="groupsConfig.enviarAprovadas && config.enviarAprovadas"
              multiple
              label="Selecione Arquivos de Evidência"
              v-model="props.item.arquivos"
            >
            </v-file-input>
          </template>
        </td>
        <td>
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-btn
              v-if="groupsConfig.enviarAprovadas && config.enviarAprovadas"
              color="primary"
              class="ml-3"
              @click="sendEvidences(props.item)"
            >
              <span v-if="isSala">Carregar</span>
              <span v-else>Enviar</span>
            </v-btn>
          </template>
        </td>
        <td v-if="props.item.evidencia">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
            :isHtml="isSala ? true : false"
            v-if="props.item.evidencia.length > 0"
          >
          </app-modal-show-evidence>
        </td>
        <td v-else></td>

        <td v-if="props.item.temArquivo">
          <div class="hasEvidence"></div>
        </td>
        <td v-if="!props.item.temArquivo">
          <div class="hasNoEvidence"></div>
        </td>
      </tr>
    </template>
    <template v-slot:expanded-item="props">
      <tr
        v-if="
          isFullAdmin ||
          (groupsConfig.visualizarAprovadas && config.visualizarAprovadas)
        "
      >
        <td colspan="9" class="p-0">
          <app-get-evidence-question
            :perguntaId="props.item.perguntaMunicipioId"
            @updateValue="updateValue"
            :evidences="evidences"
            :type="'Aprovadas'"
          ></app-get-evidence-question>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
  <aprovadas-selo
    :visualizarPontosMedalha="visualizarPontosMedalha"
    :headers="headers"
    :headersSemPontos="headersSemPontos"
    :perguntasAprovadas="perguntasAprovadas"
    :payload="payload"
    :rulesArquivo="rules"
    :expanded="expanded"
    @openEvidence="openEvidence"
    :evidences="evidences"
    @removeQuestion="removeQuestion"
    @updateValue="updateValue"
    v-else
  ></aprovadas-selo>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import { sortArrayAsc } from "../../../../helpers/utils";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import AppGetEvidenceQuestion from "@/modules/evidence/components/GetQuestion";
import Swal from "sweetalert2";
import AprovadasSelo from "./selo/AprovadasSelo.vue";

export default {
  components: {
    AppModalShowEvidence,
    AppGetEvidenceQuestion,
    AprovadasSelo,
  },
  data() {
    return {
      headers: [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "", value: "aaa" },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "vvv" },
        { text: "", value: "enviar" },
        { text: "Evidência", value: "pergunta.evidencia" },
        { text: "Arquivo", value: "evidenciado" },
      ],
      headersSemPontos: [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "", value: "aaa" },
        { text: "", value: "vvv" },
        { text: "", value: "enviar" },
        { text: "Evidência", value: "pergunta.evidencia" },
        { text: "Arquivo", value: "evidenciado" },
      ],
      municipioId: this.$route.params.id,
      aux: [],
      perguntasAprovadas: [],
      allPerguntasAprovadas: [],
      expanded: [],
      evidences: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      payload: {},
      rules: [
        (files) => {
          if (files) {
            var somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);

            return somaTotal > 26214400
              ? "Total de arquivos não pode ser maior que 25MB!"
              : true;
          }

          return !files;
        },
      ],
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
    visualizarPontosMedalha: false,
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        if (val.temas.length)
          this.perguntasAprovadas = this.allPerguntasAprovadas.filter((pa) =>
            val.temas.some((te) => te.nome === pa.nome)
          );
        else this.perguntasAprovadas = this.allPerguntasAprovadas;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    removeQuestion(pergunta) {
      Swal.fire({
        title: "Atenção!",
        text: `Deseja realmente DESCARTAR esta questão e todas as suas evidências para retorno da mesma à
             situação de RESPONDIDAS? Desta forma, no próximo acompanhamento a questão aparecerá novamente e o
             município perderá os pontos correspondentes`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);
          cityQuestionAPI
            .atualizarPergunta(pergunta.perguntaMunicipioId)
            .then(() => {
              this.loadApprovedQuestions();
            })
            .catch(() => {
              this.setLoading(false);
              this.$notification.error("Erro ao salvar remover questão");
            });
        }
      });
    },
    openEvidence(evidenceSlot) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item === evidenceSlot) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }

      if (this.expanded[0]) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(this.expanded[0].perguntaMunicipioId)
          .then((resp) => {
            this.evidences = resp.data.evidencias;
            this.evidences = this.evidences.map((item) => ({
              ...item,
              justificativa:
                !item.justificativa || item.justificativa === "undefined"
                  ? ""
                  : item.justificativa,
            }));
            this.setLoading(false);
          })
          .catch(() => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter pergunta");
          });
      }
    },
    sendEvidences(question) {
      if (question.arquivos.length === 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
      } else {
        this.setLoading(true);

        let formData = new FormData();

        for (let i = 0; i < question.arquivos.length; i++) {
          formData.append("arquivos", question.arquivos[i]);
        }

        formData.append("perguntaMunicipioId", question.perguntaMunicipioId);

        cityQuestionAPI
          .salvarEvidencias(formData)
          .then((resp) => {
            this.$notification.success("Evidência salva com sucesso");
            this.loadApprovedQuestions();
            this.expanded = [];
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar evidência");
          });
      }
    },
    async loadApprovedQuestions() {
      this.setLoading(true);
      await cityQuestionAPI
        .getAprovadas(this.$route.params.id)
        .then((resp) => {
          this.perguntasAprovadas = resp.data.sort((a, b) => {
            return (
              sortArrayAsc(a.nome, b.nome) || sortArrayAsc(a.texto, b.texto)
            );
          });

          if (!this.user.grupo.verTodosEixos) {
            this.perguntasAprovadas = this.perguntasAprovadas.filter((item) =>
              this.user.permissoes.some(
                (per) =>
                  per.eixoId === item.eixoId &&
                  per.municipioId === item.municipioId
              )
            );
          }
          this.allPerguntasAprovadas = this.perguntasAprovadas;
          if (this.filter.temas.length > 0) {
            this.perguntasEvidenciadas = this.allPerguntas.filter((pa) =>
              this.filter.temas.some((te) => te.nome === pa.nome)
            );
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("Erro ao listas perguntas aprovadas: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    loadQuestion(perguntaMunicipioId, index) {
      cityQuestionAPI
        .getPergunta(perguntaMunicipioId)
        .then((resp) => {
          this.perguntasAprovadas[index].evidencias = resp.data.evidencias;
          this.allPerguntasAprovadas = this.perguntasAprovadas;
          this.$forceUpdate();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    updateValue(e) {
      this.loadApprovedQuestions();
    },
  },
  mounted() {
    this.loadApprovedQuestions();
    if (this.isSala) {
      this.headers = [
        { text: "Pilar", value: "pergunta.tema.nome" },
        { text: "Faixa", value: "pergunta.faixanome" },
        { text: "Critério", value: "pergunta.texto" },
        { text: "", value: "aaa" },
        { text: "Evidência", value: "pergunta.evidencia" },
        { text: "Arquivo", value: "evidenciado" },
        { text: "Complemento", value: "aaa" },
      ];
      this.headersSemPontos = [
        { text: "Pilar", value: "pergunta.tema.nome" },
        { text: "Faixa", value: "pergunta.faixanome" },
        { text: "Critério", value: "pergunta.texto" },
        { text: "", value: "aaa" },
        { text: "Evidência", value: "pergunta.evidencia" },
        { text: "Arquivo", value: "evidenciado" },
        { text: "Complemento", value: "aaa" },
      ];
    } else {
      this.headers = [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "", value: "aaa" },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "vvv" },
        { text: "", value: "enviar" },
        { text: "Evidência", value: "pergunta.evidencia" },
        { text: "Arquivo", value: "evidenciado" },
      ];
    }
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isFullAdmin",
      "isSala",
      "isParceiro",
    ]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
